import { getRuntimeConfig } from '@retail/funnel-components';

__webpack_public_path__ = getRuntimeConfig('ASSETS_PUBLIC_PATH');
